"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var _two = _interopRequireDefault(require("@/components/upload/two"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PCDetail',
  components: {
    upload: _two.default
  },
  data: function data() {
    return {
      id: this.$route.query.id,
      appid: this.$route.query.appid,
      info: {},
      formInfo: {
        complaint_id: this.$route.query.id,
        appid: this.$route.query.appid
      },
      formDialog: false,
      formEnd: false,
      list: [],
      operateType: {
        USER_CREATE_COMPLAINT: '用户提交投诉',
        USER_CONTINUE_COMPLAINT: '用户继续投诉',
        USER_RESPONSE: '用户留言',
        PLATFORM_RESPONSE: '平台留言',
        MERCHANT_RESPONSE: '商户留言',
        MERCHANT_CONFIRM_COMPLETE: '商户处理完成',
        COMPLAINT_FULL_REFUNDED: '投诉单全额退款',
        USER_CREATE_COMPLAINT_SYSTEM_MESSAGE: '用户提交投诉系统通知',
        COMPLAINT_FULL_REFUNDED_SYSTEM_MESSAGE: '投诉单全额退款系统通知',
        USER_CONTINUE_COMPLAINT_SYSTEM_MESSAGE: '用户继续投诉系统通知',
        MERCHANT_CONFIRM_COMPLETE_SYSTEM_MESSAGE: '商户处理完成系统通知',
        USER_REVOKE_COMPLAINT: '用户主动撤诉',
        USER_COMFIRM_COMPLAINT: '用户确认投诉解决'
      },
      statu: {
        PENDING: "待处理",
        PROCESSING: "处理中",
        PROCESSED: "已处理完成"
      }
    };
  },
  mounted: function mounted(options) {
    this.getInfo();
    this.getList();
  },
  methods: {
    /**
     * 获取详情
     */
    getInfo: function getInfo() {
      var _this = this;
      this.$get('agentapi/analysis/wx_complaint_detail', {
        complaint_id: this.id,
        appid: this.appid
      }).then(function (res) {
        _this.info = res;
      });
    },
    /**
     * 协商历史
     */
    getList: function getList() {
      var _this2 = this;
      this.$get('agentapi/analysis/wx_complaint_history', {
        complaint_id: this.id,
        appid: this.appid
      }).then(function (res) {
        _this2.list = res.data;
      });
    },
    /**
     * 提交信息
     */
    postEdit: function postEdit(type) {
      var _this3 = this;
      var url = 'agentapi/analysis/wx_complaint_response',
        params = JSON.parse(JSON.stringify(this.formInfo));
      params.response_images = this.arrayKeys(params.response_images, 'media_id');
      this.loadObj = this.$loading({
        lock: true,
        text: '提交中',
        spinner: 'el-icon-loading'
      });
      this.$post(url, params).then(function (res) {
        _this3.loadObj.close();
        _this3.formDialog = false;
        _this3.$message({
          message: '留言成功',
          type: 'success'
        });
        _this3.getList();
      }).catch(function (err) {
        _this3.loadObj.close();
      });
    },
    /**
     * @param {Object} time RFC3339 日期格式
     * RFC3339转为标准格式日期
     */
    RFCToDate: function RFCToDate(time) {
      var date = new Date(time).toJSON();
      return new Date(+new Date(date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
    },
    /**
     * 完结投诉
     */
    endComplaint: function endComplaint() {
      var _this4 = this;
      var that = this;
      this.$alert('确定已处理完成完成反馈吗？', '完结反馈', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == 'confirm') {
            that.loadObj = that.$loading({
              lock: true,
              text: '提交中',
              spinner: 'el-icon-loading'
            });
            that.$post('agentapi/analysis/wx_complaint_complete', {
              complaint_id: that.id,
              appid: _this4.appid
            }).then(function (res) {
              that.loadObj.close();
              that.$message({
                message: '完结成功',
                type: 'success'
              });
              that.$router.push({
                path: '/userManage/payComplaints'
              });
            }).catch(function (err) {
              that.loadObj.close();
            });
          }
        }
      });
    }
  }
};